





































































































































































import Vue, { PropType } from 'vue';
import moment from 'moment';

import {
  InstallationModule,
  InstallationModuleData,
  InstallationPlan,
  MechanicInstallation,
  Nullable,
} from '@/types';

export default Vue.extend({
  props: {
    item: Object as PropType<MechanicInstallation>,
  },

  data() {
    return {
      showImageViewer: false,
      image: null as Nullable<string>,
    };
  },

  computed: {
    moduleIcon() {
      return (mod: InstallationModule) => {
        switch (mod.type) {
          case 'METER_MAAS-REGULAR':
          case 'METER-REGULAR':
            return 'fa-digital-tachograph';
          case 'PANELS-REGULAR':
            return 'fa-solar-panel';
          default:
            return '';
        }
      };
    },

    comment(): string {
      return this.item.comment ?? '';
    },

    date(): string {
      return moment(this.item.installationDate * 1000).calendar();
    },

    relativeDate(): string {
      return moment(this.item.installationDate * 1000).from(moment());
    },

    time(): string {
      return moment(this.item.installationDate * 1000).format('HH:mm');
    },

    address(): Record<string, string> {
      const [address, postalcode] = this.item.address.split(', ');
      const [street, houseNumber] = address.split(' ');

      return { houseNumber, street, postalcode };
    },

    installationPlan(): InstallationPlan | undefined {
      const panels = this.item.modules.find(mod => mod.type === 'PANELS-REGULAR');

      return panels?.installationPlan;
    },

    isMonitoringOnly(): boolean {
      return this.item.modules.some(mod => mod.type === 'METER_MAAS-REGULAR');
    },

    panelsLocation() {
      switch (this.item.screening.panelsLocation) {
        case 'voor':
          return 'Voorkant';
        case 'achter':
          return 'Achterkant';
        case 'zijkant':
          return 'Zijkant';
        case 'plat':
          return 'Plat dak';
        default:
          return 'Onbekend';
      }
    },
  },

  methods: {
    openLocation() {
      window.open(`https://maps.google.com/?q=${encodeURIComponent(this.item.address)}`, '_blank');
    },

    openImage(image: string) {
      this.showImageViewer = true;
      this.image = image;
    },
  },
});
